(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[134],{

/***/ 6485:
/***/ (function(module) {

/*! clipboard-copy. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* global DOMException */

module.exports = clipboardCopy

function makeError () {
  return new DOMException('The request is not allowed', 'NotAllowedError')
}

async function copyClipboardApi (text) {
  // Use the Async Clipboard API when available. Requires a secure browsing
  // context (i.e. HTTPS)
  if (!navigator.clipboard) {
    throw makeError()
  }
  return navigator.clipboard.writeText(text)
}

async function copyExecCommand (text) {
  // Put the text to copy into a <span>
  const span = document.createElement('span')
  span.textContent = text

  // Preserve consecutive spaces and newlines
  span.style.whiteSpace = 'pre'
  span.style.webkitUserSelect = 'auto'
  span.style.userSelect = 'all'

  // Add the <span> to the page
  document.body.appendChild(span)

  // Make a selection object representing the range of text selected by the user
  const selection = window.getSelection()
  const range = window.document.createRange()
  selection.removeAllRanges()
  range.selectNode(span)
  selection.addRange(range)

  // Copy text to the clipboard
  let success = false
  try {
    success = window.document.execCommand('copy')
  } finally {
    // Cleanup
    selection.removeAllRanges()
    window.document.body.removeChild(span)
  }

  if (!success) throw makeError()
}

async function clipboardCopy (text) {
  try {
    await copyClipboardApi(text)
  } catch (err) {
    // ...Otherwise, use document.execCommand() fallback
    try {
      await copyExecCommand(text)
    } catch (err2) {
      throw (err2 || err || makeError())
    }
  }
}


/***/ }),

/***/ 830:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news",
      function () {
        return __webpack_require__(1887);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadable = _interop_require_default(__webpack_require__(4588));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 3644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 4588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadableContext = __webpack_require__(3644);
const { useSyncExternalStore  } =  true ? __webpack_require__(7294) : 0;
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 2503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(120);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(754);
/* harmony import */ var src_layouts_components_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4381);
// ** MUI Imports



// ** Source code Imports

const FallbackSpinner = (param)=>{
    let { sx , settings  } = param;
    const { mode  } = settings;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        sx: {
            height: "100vh",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            ...sx
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_layouts_components_icons__WEBPACK_IMPORTED_MODULE_1__/* .Logotype */ .Vp, {
                width: 82,
                height: 68,
                mode: mode
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                disableShrink: true,
                sx: {
                    mt: 6
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FallbackSpinner);


/***/ }),

/***/ 2791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rV": function() { return /* reexport */ useSettings/* useSettings */.r; }
});

// UNUSED EXPORTS: useBgColor, useClipboard, useTimeFormat

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clipboard-copy/index.js
var clipboard_copy = __webpack_require__(6485);
;// CONCATENATED MODULE: ./src/@core/hooks/useClipboard.tsx
// ** React Imports

// ** Third Party Imports

const isInputLike = (node)=>{
    return node && (node.nodeName === "TEXTAREA" || node.nodeName === "INPUT");
};
const useClipboard = function() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const targetRef = useRef(null);
    const handleSuccess = ()=>{
        if (options.onSuccess) {
            options.onSuccess();
        }
        if (options.selectOnCopy && isInputLike(targetRef.current)) {
            targetRef.current.select();
        }
    };
    const handleError = ()=>{
        if (options.onError) {
            options.onError();
        }
        const selectOnError = options.selectOnError !== false;
        if (selectOnError && isInputLike(targetRef.current)) {
            targetRef.current.select();
        }
    };
    const clipboardCopy = (text)=>{
        copy(text).then(handleSuccess).catch(handleError);
    };
    const copyHandler = useCallback((text)=>{
        if (typeof text === "string") {
            clipboardCopy(text);
        } else if (targetRef.current) {
            clipboardCopy(targetRef.current.value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        copy: copyHandler,
        target: targetRef
    };
};
/* harmony default export */ var hooks_useClipboard = ((/* unused pure expression or super */ null && (useClipboard)));

// EXTERNAL MODULE: ./src/@core/hooks/useSettings.ts
var useSettings = __webpack_require__(1268);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
;// CONCATENATED MODULE: ./src/@core/hooks/useTimeFormat.tsx
// ** Module Imports


const useTimeFormat = ()=>{
    const { locale  } = useIntl();
    const formatDate = (value, formule)=>dayjs(value).locale(locale).format(formule);
    const formatPlaceholder = (data)=>{
        let placeholder = data;
        if (locale === "ru") {
            placeholder = data.split("").map((item)=>{
                if (item === "m") return "м";
                if (item === "h") return "ч";
                if (item === "d") return "д";
                if (item === "y") return "г";
                return item;
            }).join("");
        }
        return placeholder;
    };
    return {
        formatDate,
        formatPlaceholder
    };
};
/* harmony default export */ var hooks_useTimeFormat = ((/* unused pure expression or super */ null && (useTimeFormat)));

;// CONCATENATED MODULE: ./src/@core/hooks/index.ts







/***/ }),

/***/ 3291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8958);

/* harmony default export */ __webpack_exports__["Z"] = ({
    getNewsList: ()=>"".concat(_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].apiEndpoint */ .Z.apiEndpoint, "/api/").concat(_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].space */ .Z.space, "/database/news/row"),
    getNewDetail: ()=>"".concat(_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].apiEndpoint */ .Z.apiEndpoint, "/api/").concat(_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].space */ .Z.space, "/database/news/row")
});


/***/ }),

/***/ 1887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var effector_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4190);
/* harmony import */ var _unleash_proxy_client_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8676);
/* harmony import */ var src_core_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2791);
/* harmony import */ var src_state_manager_landing__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2088);
/* harmony import */ var src_core_components_spinner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2503);
/* harmony import */ var src_layouts_default_layout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8747);
/* harmony import */ var src_state_manager_news__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2094);
// ** React Imports


// ** Modules Imports




// ** Source code Imports





const NewsPage = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(549), __webpack_require__.e(102)]).then(__webpack_require__.bind(__webpack_require__, 6102)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6102)
            ]
    },
    ssr: false
});
const News = ()=>{
    const settings = (0,src_core_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useSettings */ .rV)();
    const { replace  } = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { landingDetails  } = (0,effector_react__WEBPACK_IMPORTED_MODULE_10__/* .useStore */ .oR)(src_state_manager_landing__WEBPACK_IMPORTED_MODULE_6__/* ["default"].landing */ .ZP.landing);
    const { data: newsData  } = (0,effector_react__WEBPACK_IMPORTED_MODULE_10__/* .useStore */ .oR)(src_state_manager_news__WEBPACK_IMPORTED_MODULE_9__/* ["default"].news */ .Z.news);
    const isLandingNewsAvailable = (0,_unleash_proxy_client_react__WEBPACK_IMPORTED_MODULE_4__/* .useFlag */ .P5)("is_landing_news_available");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,src_state_manager_news__WEBPACK_IMPORTED_MODULE_9__/* .getNewsList */ .I)({
            query: {
                ["data.showToLanding"]: true
            }
        });
        (0,src_state_manager_landing__WEBPACK_IMPORTED_MODULE_6__/* .getTableForLanding */ .hg)({
            key: "platforms",
            tableName: "landing_platforms"
        });
        (0,src_state_manager_landing__WEBPACK_IMPORTED_MODULE_6__/* .getLandingDetail */ .d_)();
    }, []);
    const isLoading = landingDetails.loading;
    if (!isLandingNewsAvailable) {
        replace("/404");
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_spinner__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                settings: settings
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_layouts_default_layout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                sx: {
                    height: isLoading ? 0 : "auto",
                    visibility: isLoading ? "hidden" : "visible"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NewsPage, {
                    landingDetails: landingDetails.data,
                    newsItems: newsData
                })
            })
        ]
    });
};
News.getLayout = (page)=>page;
/* harmony default export */ __webpack_exports__["default"] = (News);


/***/ }),

/***/ 2094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getNewsList; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(196);
/* harmony import */ var effector__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8116);
/* harmony import */ var src_configs_news__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3291);



const getNewsList = (0,effector__WEBPACK_IMPORTED_MODULE_2__/* .createEffect */ .GW)(async function() {
    let payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { data  } = await axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post(src_configs_news__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getNewsList */ .Z.getNewsList(), payload);
    return data;
});
const news = (0,effector__WEBPACK_IMPORTED_MODULE_2__/* .createStore */ .MT)({
    data: [],
    count: 0,
    pages: 0,
    loading: true
}).on(getNewsList, (state)=>{
    return {
        ...state,
        loading: true
    };
}).on(getNewsList.doneData, (state, payload)=>{
    return {
        ...state,
        data: payload.data,
        count: payload.count,
        pages: payload.pages,
        loading: false
    };
});

/* harmony default export */ __webpack_exports__["Z"] = ({
    news
});


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7645)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [524,499,773,774,888,179], function() { return __webpack_exec__(830); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);